<template>
    <div>
        <!-- Expedia Webhook Subscription Management Card -->
        <div class="card card-default mb-4">
            <div class="card-header">
                {{ __('Subscriptions') }}
            </div>
            <div class="card-body">
                <div class="ml-3 form-group">
                    <label>{{ __('Available Event Subscriptions') }}</label>
                    <div class="form-check" v-for="event in availableEvents" :key="event">
                        <input class="form-check-input my-auto" type="checkbox"
                            :id="`event-${event}`"
                            :value="event"
                            v-model="selectedEvents">
                        <label class="form-check-label" :for="`event-${event}`">
                            {{ event }}
                        </label>
                    </div>
                </div>

                <button class="btn btn-primary mt-2" @click="updateSubscriptions">
                    {{ __('Update Subscription') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import difference from 'lodash/difference';

export default {
    props: {
        connection: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            availableEvents: [
                'ReviewsApproved',
                'ReviewsManagementResponseRejected',
                'ReviewsManagementResponseApproved',
                'GuestReviewSubmitted'
            ],
            selectedEvents: this.connection.webhooks?.[0]?.config?.event_types || []
        };
    },
    methods: {
        async updateSubscriptions() {
            const webhookId = this.connection.webhooks?.[0]?.id;
            const currentEvents = this.connection.webhooks?.[0]?.config?.event_types || [];

            const addedEvents = difference(this.selectedEvents, currentEvents);
            const removedEvents = difference(currentEvents, this.selectedEvents);

            try {
                if (addedEvents.length || removedEvents.length) {
                    await axios.put(`/api/admin/integrations/${this.connection.id}/webhooks/${webhookId}`, {
                        subscribe: addedEvents,
                        unsubscribe: removedEvents,
                    });

                    this.$emit('update-connection');
                }
            } catch (error) {
                console.error('Error updating subscriptions:', error);
            }
        }
    },
    watch: {
        'connection.webhooks': {
            immediate: true,
            handler(webhooks) {
                this.selectedEvents = webhooks?.[0]?.config?.event_types || [];
            }
        }
    }
};
</script>

<style scoped>
.card-default {
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
</style>
